import { PlacesBoard } from '@/components/controls/PlacesBoard'
import '@/styles/controls.css'

/**
 * Places (/app/feed/places). A feed control: Brian's after/settings-places.html
 * v1.9 with the Oct 22 home change. Comes back to Feed controls.
 */
export function PlacesPage() {
  return <PlacesBoard />
}
